import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api/api";

export default function DeliveryVendorList() {
  const location = useLocation();
  const navigate = useNavigate();

  const type =
    new URLSearchParams(location.search).get("type") || "ontime";

  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [type]);

  const loadData = async () => {
    try {
      setLoading(true);

      const data = await api.get(
        `/vendors/delivery-vendors?type=${type}`
      );

      console.log("API RESULT:", data);
      console.log("IS ARRAY:", Array.isArray(data));

      if (Array.isArray(data)) {
        setVendors(data);
      } else if (Array.isArray(data?.data)) {
        setVendors(data.data);
      } else if (Array.isArray(data?.rows)) {
        setVendors(data.rows);
      } else {
        setVendors([]);
      }
    } catch (err) {
      console.error(err);
      setVendors([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  return (
    <div className="p-6">

      {/* Header */}
      <div className="flex items-center justify-between mb-6">

        <div>
          <h1 className="text-2xl font-bold text-sap-text">
            {type === "ontime"
              ? "On-Time Vendors"
              : "Late Vendors"}
          </h1>

          <p className="text-sm text-gray-500">
            Vendor Risk Management / Delivery Performance
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition"
        >
          ← Back
        </button>

      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow border overflow-auto">

        <table className="w-full border-collapse">

          <thead>

            <tr className="bg-gray-100 border-b">

              <th className="p-3 text-left font-semibold">
                Vendor Name
              </th>

              <th className="p-3 text-right font-semibold">
                On-Time %
              </th>

              <th className="p-3 text-right font-semibold">
                Late Deliveries
              </th>

            </tr>

          </thead>

          <tbody>

            {vendors.length === 0 ? (
              <tr>
                <td
                  colSpan="3"
                  className="text-center py-8 text-gray-500"
                >
                  No vendors found.
                </td>
              </tr>
            ) : (
              vendors.map((v, idx) => (
                <tr
                  key={idx}
                  className="border-t hover:bg-gray-50"
                >
                  <td className="p-3">
                    {v["Vendor Name"]}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      v.On_Time_Percentage || 0
                    ).toFixed(2)}
                    %
                  </td>

                  <td className="p-3 text-right">
                    {v.Late_Deliveries || 0}
                  </td>
                </tr>
              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}